import Marquee from "react-fast-marquee";

const ITEMS = [
  "30+ Years of Experience",
  "In-Person Primary Care",
  "Virtual Care via Doc Talk",
  "Local West Virginia Medicine",
  "Secure Patient Messaging",
  "Open Monday – Thursday",
  "Care Close to Home",
];

export const TrustMarquee = () => {
  return (
    <section
      data-testid="trust-marquee"
      className="border-y border-border bg-secondary py-5"
      aria-label="Practice highlights"
    >
      <Marquee speed={32} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-serif text-xl italic text-foreground/70 md:text-2xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-accent" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default TrustMarquee;
